export default function() {
  return `
    <div class="autocomplete-item">
      <div class="rsui-loading-dots">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  `;
}
